import React, { FunctionComponent } from 'react';
import CallsSourceGraphView from './calls-source-graph-view';
import { CallSourceChartData } from './calls-source-graph-repository';
import { Loader } from 'semantic-ui-react';

type CallsSourceGraphContainerProps = {
  chartData: CallSourceChartData[];
  availableSources: string[];
  loading: boolean;
  error: Error | null;
};

const CallsSourceGraphContainer: FunctionComponent<
  CallsSourceGraphContainerProps
> = ({ chartData, availableSources, loading, error }) => {
  if (loading) {
    return (
      <div style={{ height: 276 }}>
        <Loader
          size="large"
          active
          inline="centered"
          style={{ marginTop: 224 }}
        />
      </div>
    );
  }

  if (error) {
    return <div>Error loading chart data: {error.message}</div>;
  }

  return (
    <CallsSourceGraphView
      chartData={chartData}
      availableSources={availableSources}
    />
  );
};

export default CallsSourceGraphContainer;
